var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle-btn",class:{
  'active': _vm.isActive
},on:{"click":function($event){return _vm.$emit('onToggleClick', _vm.isActive)}}},[_vm._v(_vm._s(_vm.name))])}
var staticRenderFns = []

export { render, staticRenderFns }